(() => {
  const normalize = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "");

  /* Valores de opcao de variante que LIGAM os campos de personalizacao.
     A loja usa "Customize" (opcao "Add Name & Number"); os demais ficam por
     compatibilidade com a versao PT antiga e com traducao de mercado.
     A comparacao e por igualdade exata, entao "Don't Customize" NAO liga. */
  const VALORES_ATIVA = [
    "customize",
    "customise",
    "personalizar",
    "personalizacao",
    "com personalizacao",
    "sim",
    "yes",
  ];

  const ativaPersonalizacao = (variant) => {
    const options = Array.isArray(variant?.options) ? variant.options : [];
    return options.some((opt) => VALORES_ATIVA.indexOf(normalize(opt)) !== -1);
  };

  function getInitialVariantFromSection(productInfoEl) {
    const script = productInfoEl?.querySelector('variant-selects script[data-selected-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Re-consulta o wrapper no DOM a cada uso: o Dawn substitui o HTML do
     product-info ao trocar de variante, e uma referencia guardada fica orfa. */
  function findWrapper(sectionId) {
    return document.querySelector(
      `[data-personalizacao-wrapper][data-section-id="${sectionId}"]`
    );
  }

  /* O motor da previa do nome e do numero (ui-nameset.js) so vem quando a personalizacao
     liga de verdade. A URL vem do proprio HTML, no data-ui-ns-src que o snippet escreve:
     asset_url e versionado por hash, entao nao da pra montar essa URL no JS.

     Por que sob demanda e nao um <script defer> no HTML: a maioria das visitas a uma PDP
     nao clica em "Customize". Poupar essas visitas de baixar o motor e uma requisicao e
     alguns KB e a diferenca entre um recurso que custa a todo mundo e um que custa a quem
     usa. Quem liga paga uma vez, e o arquivo fica no cache pro resto da navegacao. */
  function carregarPreview(wrapper) {
    if (!wrapper) return;
    /* Dois motores independentes, cada um com o seu atributo: a previa da camisa
       (ui-nameset) e as abas de jogador (ui-jogadores). Sao separados porque as
       coberturas nao coincidem - 378 produtos tem escalacao e nao tem previa medida, e
       juntar os dois faria essas PDPs baixarem um motor de desenho que nunca desenha. */
    ["data-ui-ns-src", "data-ui-jg-src"].forEach(function (attr) {
      const raiz = wrapper.querySelector("[" + attr + "]");
      if (!raiz) return;
      const src = raiz.getAttribute(attr);
      if (!src || document.querySelector('script[data-ui-motor="' + src + '"]')) return;
      const s = document.createElement("script");
      s.src = src;
      s.defer = true;
      s.dataset.uiMotor = src;
      document.head.appendChild(s);
    });
  }

  /* O campo Numero aceitava qualquer tecla: o pattern="[0-9]*" esta no HTML, mas o form de
     compra tem novalidate, entao o navegador sabe que e invalido e nunca e perguntado.
     Medido em 11/09/2026: "-7" e "7B" desenhavam 7 na previa e gravavam o valor cru no
     pedido, e a planilha da fornecedora saia com a coluna Number dizendo "-7" ao lado de
     uma foto mostrando 7 - tres versoes da mesma camisa.

     A limpeza aqui e a MESMA que o textoNumero() do ui-nameset.js ja fazia so pra desenhar;
     a diferenca e que agora ela volta pro campo, entao o que o cliente ve, o que o pedido
     grava e a foto que vai pra fabrica saem da mesma fonte.

     Mora NESTE arquivo e nao no motor da previa porque o ui-nameset.js sai fora logo no
     inicio quando a camisa nao tem previa configurada, e o campo existe em toda camisa.
     O teto vem do proprio maxlength do campo, pra nunca brigar com uma camisa que aceite
     mais digitos. */
  function limitarNumero(campo) {
    if (!campo || campo.dataset.uiSoDigito === "1") return;
    campo.dataset.uiSoDigito = "1";
    campo.addEventListener("input", () => {
      const max = parseInt(campo.getAttribute("maxlength"), 10) || 2;
      const limpo = campo.value.replace(/\D/g, "").slice(0, max);
      if (campo.value !== limpo) campo.value = limpo;
    });
  }

  function togglePersonalizacao(wrapper, variant) {
    if (!wrapper) return;

    const campos = Array.from(wrapper.querySelectorAll("input, select, textarea"));

    if (ativaPersonalizacao(variant)) {
      wrapper.classList.remove("hidden");
      campos.forEach((campo) => {
        campo.disabled = false;
      });
      limitarNumero(wrapper.querySelector('[name="properties[Number]"]'));
      carregarPreview(wrapper);
    } else {
      wrapper.classList.add("hidden");
      campos.forEach((campo) => {
        campo.value = "";
        campo.disabled = true;
      });
    }
  }

  function initPersonalizacaoForProductInfo(productInfoEl) {
    const sectionId = productInfoEl?.dataset?.section;
    if (!sectionId) return;
    if (productInfoEl.dataset.persoInit === "1") return;
    productInfoEl.dataset.persoInit = "1";

    /* Gatilho antecipado: quem encosta no seletor de variante esta a um passo de escolher
       "Customize". Buscar o motor aqui faz ele chegar antes do clique, entao o painel abre
       ja montado em vez de piscar vazio. `once` porque uma vez basta. */
    productInfoEl.addEventListener(
      "pointerdown",
      () => carregarPreview(findWrapper(sectionId)),
      { once: true, passive: true }
    );

    /* 1) estado inicial */
    togglePersonalizacao(findWrapper(sectionId), getInitialVariantFromSection(productInfoEl));

    /* 2) quando mudar variante (evento nativo do Dawn) */
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data;
        if (!data || data.sectionId !== sectionId) return;
        togglePersonalizacao(findWrapper(sectionId), data.variant);
        /* reforco no frame seguinte, caso o re-render do Dawn chegue depois do evento */
        requestAnimationFrame(() =>
          togglePersonalizacao(findWrapper(sectionId), data.variant)
        );
      });
    }
  }

  const initAll = () => {
    document.querySelectorAll("product-info").forEach(initPersonalizacaoForProductInfo);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
